import { render, staticRenderFns } from "./InfoInStock.vue?vue&type=template&id=41aeae18&"
import script from "./InfoInStock.vue?vue&type=script&lang=js&"
export * from "./InfoInStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports